import { RideDispatchTypes, VIEW_RIDE } from "./types";
import { Dispatch } from 'redux';

export const selectRide = (entry: any) => async (dispatch: Dispatch<RideDispatchTypes>) => {
  dispatch({type: VIEW_RIDE, payload: entry});
}